import React from "react";
import SeloReclameAqui from "components/SeloReclameAqui"; 

import { Row, Col, Container } from 'reactstrap'; 
import Button from "components/Button";
  
import {
    CommomContainer, 
    CommomTitle, 
    CommomText,
    CommomImageBanner,
    CommomCentred,
    BannerCenterActions,
    BannerTitle,
    ColorLink
} from './styled'

export default function FaleConosco(){  

    return ( 
        <> 
            <CommomContainer>  
                <Container> 
                    <Row>
                        <Col md={{size:6}}> 
                            <CommomCentred spaced>
                                <CommomTitle>Fale com a gente</CommomTitle>
                                <CommomText>WhatsApp (92) 98216-8732</CommomText>
                                <CommomText>e-mail: atendimento@joinkids.com.br</CommomText>
                                <CommomText>PIX para Doações: 31.570.972/0001-45</CommomText>
                                <SeloReclameAqui />
                                <BannerCenterActions>
                                    {/* <Button accent onClick={() => navigate('planos')}>Fale com a gente</Button> */}
                                    <BannerTitle><a href="https://wa.me/5592982168732?text=Eu%20tenho%20dúvidas!"><ColorLink><Button secondary>Fale com a gente</Button></ColorLink></a></BannerTitle>
                                </BannerCenterActions>
                            </CommomCentred>
                        </Col>
                        <Col md={{size:6}}> 
                            <CommomCentred>
                                <CommomImageBanner />
                            </CommomCentred>
                        </Col>
                    </Row>
                </Container>
            </CommomContainer>
        </>
    );
}